import { render, staticRenderFns } from "./CoaOilEhxto.vue?vue&type=template&id=4e89dc24&scoped=true&"
import script from "./CoaOilEhxto.vue?vue&type=script&lang=js&"
export * from "./CoaOilEhxto.vue?vue&type=script&lang=js&"
import style0 from "./CoaOilEhxto.vue?vue&type=style&index=0&id=4e89dc24&prod&lang=scss&scoped=true&"
import style1 from "./CoaOilEhxto.vue?vue&type=style&index=1&id=4e89dc24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e89dc24",
  null
  
)

export default component.exports